import client from './client';

export interface MemoryItem {
  readonly id: string;
  readonly text: string;
  readonly type: string;
  readonly conversationId: string | null;
  readonly date: string | null;
  readonly entities: string | null;
  readonly tags: string | null;
}

export interface MemoryPage {
  readonly items: readonly MemoryItem[];
  readonly total: number;
  readonly limit: number;
  readonly offset: number;
}

export async function fetchUserMemories(
  limit = 20,
  offset = 0
): Promise<MemoryPage> {
  const { data } = await client.get<MemoryPage>('/api/v1/memories/user', {
    params: { limit, offset },
  });
  return data;
}

export async function fetchOrgMemories(
  limit = 20,
  offset = 0
): Promise<MemoryPage> {
  const { data } = await client.get<MemoryPage>('/api/v1/memories/org', {
    params: { limit, offset },
  });
  return data;
}

export async function deleteUserMemory(memoryId: string): Promise<void> {
  await client.delete(`/api/v1/memories/user/${memoryId}`);
}

export async function deleteOrgMemory(memoryId: string): Promise<void> {
  await client.delete(`/api/v1/memories/org/${memoryId}`);
}
